module.exports = __webpack_public_path__ + "static/img/error-thumb.334518f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/error-thumb.png
// module id = biiR
// module chunks = 1